<template>
  <div>
    <el-dialog :visible.sync="visible" width="45%" :before-close="close">
      <!-- 弹窗1 -->
      <template #title>
        <span style="color: #fff; font-weight: bold; font-size: 16px" v-show="drugInformation"
          >医保结算</span
        >
        <span style="color: #fff; font-weight: bold; font-size: 16px" v-show="selectionMethod || patientInformation"
          >身份识别</span
        >
        <span style="color: #fff; font-weight: bold; font-size: 16px" v-show="submitSettlement"
          >预结算</span
        >
      </template>
      <template>
        <!-- 弹窗1 -->
        <div v-show="drugInformation">
          <el-row type="flex" style="margin: 10px 0">
            <el-col :span="10">
              医生 <el-input v-model="docName" style="width: 150px"></el-input>
            </el-col>
            <el-col> 诊断 <el-input style="width: 150px"></el-input> </el-col>
          </el-row>
          <el-table :data="list" style="margin-top: 20px;">
            <el-table-column prop="drugName" label="收费项目"></el-table-column>
            <el-table-column prop="name" label="国家医保编码"></el-table-column>
            <el-table-column prop="salePrice" label="单价"></el-table-column>
            <el-table-column prop="dosage" label="数量"></el-table-column>
            <el-table-column prop="saleUnit" label="单位"></el-table-column>
            <el-table-column label="金额">
              <template slot-scope="scope">
                <span>{{ (scope.row.salePrice * scope.row.dosage).toFixed(2) }}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-row
            type="flex"
            justify="space-between"
            align="certer"
            style="margin-top: 40px"
          >
            <el-col :span="10" style="line-height: 36px; color: #999999">
              中药1项，西药3项，医用材料2项
            </el-col>
            <el-col :span="10">
              <span>刷卡金额</span>
              <span style="color: #ffa500; margin: 0 10px">￥888.00</span>
              <el-button type="primary" style="width: 84px; height: 34px"
                @click="goToSelectMethod"
                >结算</el-button
              >
            </el-col>
          </el-row>
        </div>
        <!-- 弹窗2 -->
        <div v-show="selectionMethod">
          <el-row style="margin-bottom: 10px">
            <el-button type="text" icon="iconfont icon-fanhui" @click="firstReturn">返回</el-button>
          </el-row>
          <el-row type="flex" justify="center">
            <el-radio-group v-model="radio" >
              <el-radio :label="3" border>医保卡</el-radio>
              <el-radio :label="6" border>医保电子凭证</el-radio>
              <el-radio :label="9" border>身份证</el-radio>
            </el-radio-group>
          </el-row>
          <el-row type="flex" justify="center" style="margin: 50px 0">
            <img
              src="@/assets/home/Vector@2x.png"
              style="width: 180px; height: 112px"
            />
          </el-row>
          <el-row type="flex" justify="center" align="center">
            <span style="line-height: 36px; margin-right: 20px"
              >电子凭证编码</span
            >
            <el-input style="width: 300px"></el-input>
          </el-row>
          <el-row type="flex" justify="end" style="margin-top: 40px">
            <el-button type="primary" size="small" @click="getPatientInformation">下一步</el-button>
          </el-row>
        </div>
        <!-- 弹窗3 -->
        <div v-show="patientInformation">
          <el-row style="margin-bottom: 10px">
            <el-button type="text" icon="iconfont icon-fanhui" @click="secondReturn">返回</el-button>
          </el-row>
          <el-row
            type="flex"
            style="
              background-color: #edf4fc;
              padding: 10px;
              margin-bottom: 30px;
            "
          >
            <el-col :span="7">
              <el-row>持卡人：{{ patientName }} {{gender}} {{age}}岁</el-row>
              <el-row>类别：{{psnType}}</el-row>
              <el-row>公务员：{{civilServant}}</el-row>
            </el-col>
            <el-col :span="9">
              <el-row>身份证：{{ idCard }}</el-row>
              <el-row>险种：{{ insuType }}</el-row>
              <el-row>慢特病：{{ chronic }}</el-row>
            </el-col>
            <el-col :span="8">
              <el-row>单位：{{ unit }}</el-row>
              <el-row>参保地：{{ insuArea }}</el-row>
              <el-row>余额：{{ balance }}</el-row>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <span style="line-height: 36px; margin-right: 20px">医疗类别</span>
            <el-select v-model="value" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-row>
          <el-row type="flex" justify="end" style="margin-top: 40px">
            <el-button type="primary" size="small" @click="goToSubmitSettlement">确认</el-button>
          </el-row>
        </div>
        <!-- 弹窗4 -->
        <div v-show="submitSettlement">
          <el-row style="margin-bottom: 10px">
            <el-button type="text" icon="iconfont icon-fanhui" @click="thirdReturn">返回</el-button>
          </el-row>
          <el-row type="flex" justify="center" style="margin: 10px 0">
            <el-col :span="6">医疗费用总额</el-col>
            <el-col :span="3"
              ><span style="color: #ffa500">1.00</span>元</el-col
            >
          </el-row>
          <el-row type="flex" justify="center" style="margin: 10px 0">
            <el-col :span="6">基金支付总额</el-col>
            <el-col :span="3">0.00元</el-col>
          </el-row>
          <el-row type="flex" justify="center" style="margin: 10px 0">
            <el-col :span="6">个账支出总额</el-col>
            <el-col :span="3">0.00元</el-col>
          </el-row>
          <el-row type="flex" justify="center" style="margin-top: 40px">
            <el-col :span="4">卡内余额</el-col>
            <el-col :span="6">结算前：18888.00</el-col>
            <el-col :span="6">结算后：18887.00</el-col>
          </el-row>
          <el-row type="flex" justify="end" style="margin-top: 40px">
            <el-button type="primary" size="small" @click="close">提交结算</el-button>
          </el-row>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import getFields from '@/utils/inputMessage/index'
import {getGender,getInsutype,getProvinceByCode,getPersonType,getFormatDate2} from '@/utils/insurance/index'
export default {
  name: "continuousDialog",
  data() {
    return {
      radio: 3,
      options: [
        {
          value: "选项1",
          label: "普通门诊",
        },
        {
          value: "选项2",
          label: "特殊门诊",
        },
        {
          value: "选项3",
          label: "异地门诊",
        },
      ],
      value: "",
      drugInformation: true,
      selectionMethod: false,
      patientInformation: false,
      submitSettlement: false,
      patientName:'',
      gender:'',
      age:'',
      idCard:'',
      unit:'',
      psnType:'',//人员类别
      insuType:'',//险种
      insuArea:'',//参保地
      civilServant:'',//公务员标志
      chronic:'',//慢特病
      balance:'',//余额
      insuplcAdmdvs:'',//参保地医保区划
      info:{
        psn_no:'',
        insutype:'',
        begntime:'',
        mdtrt_cert_type:'',
        mdtrt_cert_no:'',
        psn_cert_type:'',
        certno:'',
        psn_type:'',
        psn_name:'',
        ipt_otp_no:'01',//唯一流水号
        atddr_no:'',//医生编码
        dr_name:'',//医生姓名
        dept_code:'5145',//科室编码
        dept_name:'呼吸科',//科室名称
        caty:'A03.01',//科别
      },//2201接口需要的参数
      

    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    docName:{
      type:String,
      default:''
    },
    list:{
      type:Array,
      default:[]
    },
    doctorId:{

    },
  },
  methods: {
    close(){
      this.$emit("close");
    },
    goToSelectMethod(){
      this.drugInformation = false;
      this.selectionMethod = true;
      console.log(this.list,'this.list');
    },
    firstReturn(){
      this.drugInformation = true;
      this.selectionMethod = false;
    },
    getPatientInformation(){
      this.selectionMethod = false;
      this.patientInformation = true;
      const obj = getFields('1101')
      const params = {
        ...obj,
        input:{
          data:{
            // 李海430224198709130098
            // mdtrt_cert_type:'02',
            // mdtrt_cert_no:'420684198707225030',
            // psn_cert_type:'01',
            // certno:'420684198707225030',
            // psn_name:'吴章涛'
            // mdtrt_cert_type:'02',
            // mdtrt_cert_no:'430224198709130098',
            // psn_cert_type:'01',
            // certno:'430224198709130098',
            // psn_name:'李海'
            // mdtrt_cert_type:'02',
            // mdtrt_cert_no:'430903198307263011',
            // psn_name:'胡水科'
            mdtrt_cert_type:'02',
            mdtrt_cert_no:'430621198410142759',

          }
        }
      }
      console.log(params,'params');
      console.log(this.doctorId,'this.doctorId');
      this.$api.insurance.getInfoAPI(params).then(res=>{
        console.log(res.data,'res.data')
        let {baseinfo,insuinfo} = res.data.output
        console.log(baseinfo,'baseinfo');
        console.log(insuinfo,'insuinfo');
        this.info.psn_no = baseinfo.psn_no
        this.info.insutype = insuinfo[0].insutype
        this.info.begntime = getFormatDate2()
        this.info.mdtrt_cert_type = '02'
        this.info.mdtrt_cert_no = '420684198707225030'
        this.info.psn_cert_type = '01'
        this.info.certno = '420684198707225030'
        this.info.psn_type = insuinfo[0].psn_type
        this.info.psn_name = baseinfo.psn_name
        // this.info.atddr_no = this.doctorId.toString()
        // this.info.dr_name = this.docName
        this.info.atddr_no = 'D430111022228'
        this.info.dr_name = '孙玲'
        this.insuplcAdmdvs = insuinfo[0].insuplc_admdvs
        this.patientName = baseinfo.psn_name
        this.gender = getGender(baseinfo.gend)
        this.age = Math.floor(baseinfo.age)
        this.idCard = baseinfo.certno
        this.unit = insuinfo[0].emp_name
        this.psnType = getPersonType(insuinfo[0].psn_type)
        this.insuType = getInsutype(insuinfo[0].insutype)
        this.insuArea = getProvinceByCode(insuinfo[0].insuplc_admdvs)
        this.civilServant = insuinfo[0].cvlserv_flag == '1' ? '在职' : '否'
        this.balance = insuinfo[0].balc
        const psnNo = baseinfo.psn_no
        const params2 = {
          ...getFields('5301'),
          input:{
            data:{
              psn_no:psnNo
            }
          }
        }
        console.log(params2,'5301');
        this.$api.insurance.getChronicAPI(params2).then(res => {
          const {feedetail} = res.data.output
          this.chronic = feedetail == null ? '无' : feedetail.opsp_dise_name
        })
      })
    },
    secondReturn(){
      this.selectionMethod = true;
      this.patientInformation = false;
    },
    goToSubmitSettlement(){
      this.patientInformation = false;
      this.submitSettlement = true;
      const params = {
        ...getFields('2201'),
        insuplc_admdvs: this.insuplcAdmdvs,
        input:{
          data:{
            ...this.info
          }
        }
      }
      console.log(params,'2201入参');
      this.$api.insurance.getRegisterAPI(params).then(res=>{
        console.log(res,'res');
        const {data} = res.data.output
        const params2 = {
          ...getFields('2203'),
          input:{
            mdtrtinfo:{
              mdtrt_id:data.mdtrt_id,
              psn_no:data.psn_no,
              med_type:'11',//普通门诊
              begntime:getFormatDate2(),
              dise_codg:'BJ11800',
              dise_name:'流行性感冒伴有其他表现，病毒未标明',
            },
            diseinfo:{
              diag_type:'1',//1、西医诊断 2、中医主病诊断 3、中医主证诊断 
              diag_srt_no:1,//诊断排序号
              diag_code:'A01.000x007',//诊断代码
              diag_name:'伤寒逍遥型',//诊断名称
              diag_dept:'null',//诊断科室
              dise_dor_no:'D430111022228',//诊断医生编码
              dise_dor_name:'孙玲',//诊断医生姓名
              diag_time:getFormatDate2(),//诊断时间
              vali_flag:'1',//有效标志 0、无效 1、有效
            },
          }
        }
        console.log(params2,'2203入参');
        this.$api.insurance.outpatientInfoUploadAPI(params2).then(res=>{
          console.log(res,'res');
          console.log(data,'data555');
          const params3 = {
            ...getFields('2204'),
            input:{
              feedetail:[
                {
                  feedetl_sn:new Date().getTime(),//费用明细流水号  不能重复
                  mdtrt_id:data.mdtrt_id,//就诊ID
                  psn_no:data.psn_no,//人员编号
                  chrg_bchno:'01',//收费批次号
                  rx_circ_flag:'0',//外购处方标志 暂不知道值
                  fee_ocur_time:getFormatDate2(),//费用发生时间
                  // med_list_codg:'XR05XXY213A001020401201',//医疗目录编码 愈创维林那敏片
                  // medins_list_codg:'XR05XXY213A001020401201',//医药机构目录编码
                  med_list_codg:'XR03BAB165L023020400545',//医疗目录编码 吸入用布地奈德混悬液
                  medins_list_codg:'XR03BAB165L023020400545',//医药机构目录编码
                  det_item_fee_sumamt:20,//明细项目费用总额
                  cnt:2,//数量
                  pric:10,//单价
                  bilg_dept_codg:'01',//开单科室编码
                  bilg_dept_name:'内科',//开单科室名称
                  bilg_dr_codg:'D430111022228',//开单医生编码
                  bilg_dr_name:'孙玲 ',//开单医生姓名
                  hosp_appr_flag:'0',//医院审批标志 0无需审批 1审批通过 2审批不通过
                },
                // {
                //   feedetl_sn:new Date().getTime()+1,//费用明细流水号
                //   mdtrt_id:data.mdtrt_id,//就诊ID
                //   psn_no:data.psn_no,//人员编号
                //   chrg_bchno:'01',//收费批次号
                //   rx_circ_flag:'0',//外购处方标志 暂不知道值
                //   fee_ocur_time:getFormatDate2(),//费用发生时间
                //   med_list_codg:'XR06AAB058A001010204187',//医疗目录编码 苯海拉明
                //   medins_list_codg:'XR06AAB058A001010204187',//医药机构目录编码
                //   det_item_fee_sumamt:30,//明细项目费用总额
                //   cnt:1,//数量
                //   pric:30,//单价
                //   bilg_dept_codg:'01',//开单科室编码
                //   bilg_dept_name:'内科',//开单科室名称
                //   bilg_dr_codg:'D430111022228',//开单医生编码
                //   bilg_dr_name:'孙玲 ',//开单医生姓名
                //   hosp_appr_flag:'0',//医院审批标志 0无需审批 1审批通过 2审批不通过
                // }
              ]
            }
          }
          console.log(params3,'2204');
          this.$api.insurance.outpatientDetailUploadAPI(params3).then(res=>{
            console.log(res,'res2222');
            const {result} = res.data.output
            let totalPric = result.reduce((acc,item) => acc + item.det_item_fee_sumamt,0)
            console.log(totalPric,'totalPric');
            const params4 = {
              ...getFields('2206'),
              insuplc_admdvs: this.insuplcAdmdvs,
              input:{
                data:{
                  psn_no:data.psn_no,//人员编号
                  mdtrt_cert_type:'02',//就诊凭证类型
                  mdtrt_cert_no:'420684198707225030',//就诊凭证编号
                  psn_cert_type:'01',//证件类型
                  certno:'420684198707225030',//证件号码
                  psn_type:'11',//人员类别 11在职
                  psn_name:'吴章涛',//人员姓名
                  med_type:'11', //医疗类别  11普通门诊
                  medfee_sumamt: totalPric,//医疗费总额
                  psn_setlway:'01',//个人结算方式  01按项目结算 02 按定额结算
                  mdtrt_id:data.mdtrt_id,//就诊ID
                  chrg_bchno:'01',//收费批次号
                  acct_used_flag:'0',//个人账户使用标志 0不使用 1使用
                  insutype:'310',//险种类型
                }
              }
            }
            console.log(params4,'2206');
            this.$api.insurance.outpatientPreSettlementAPI(params4).then(res => {
              console.log(res,'门诊预结算');
            })
          })
        })
      })
    },
    thirdReturn(){
      this.patientInformation = true;
      this.submitSettlement = false;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 10px 20px 30px;
}
</style>